import styled, { css } from "styled-components";
import {
  IStyled,
  TextType,
} from "components/Atoms/StrapiTreeText/StrapiTreeTextModel";
import {
  COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  ROW_SPACING,
  SIZE,
} from "constants/variables";

export const StrapiTreeTextContainer = styled.div``;
export const StrapiMarkup = styled.div`
  & > p {
    margin: ${SIZE.max10} 0;
  }

  & > pre > code {
    text-wrap: pretty;
  }

  & ol,
  ul {
    margin: ${SIZE.max28};
    > li {
      &::marker {
        font-weight: bold;
      }

      margin: ${SIZE.max28};
    }
  }
`;

export const StrapiTreeTextLabel = styled.span<IStyled>`
  && {
    font-family: ${FONT_FAMILY.poppins};

    color: ${({ color }) => color || "inherit"};
    ${({
      type,
      accessibilityBiggerText,
      accessibilityBiggerLineHeight,
      accessibilityBiggerLetterSpacing,
    }) => {
      let color;
      let fontSize;
      let fontWeight;
      let letterSpacing;
      let lineHeight;

      switch (type) {
        case TextType.H1:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.max40
            : FONT_SIZE.max45;
          fontWeight = FONT_WEIGHT.semiBold;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max60
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.max55
              : ROW_SPACING.max48;
          letterSpacing = !accessibilityBiggerLetterSpacing ? 0 : "4px";
          break;
        case TextType.H2:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.max32
            : FONT_SIZE.max40;
          fontWeight = FONT_WEIGHT.semiBold;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max55
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.max48
              : ROW_SPACING.max40;
          letterSpacing = !accessibilityBiggerLetterSpacing ? 0 : "3px";
          break;
        case TextType.H3:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.max24
            : FONT_SIZE.max32;
          fontWeight = FONT_WEIGHT.semiBold;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max48
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.max40
              : ROW_SPACING.max32;
          letterSpacing = !accessibilityBiggerLetterSpacing ? 0 : "2px";
          break;
        case TextType.H4:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.max18
            : FONT_SIZE.max24;
          fontWeight = FONT_WEIGHT.semiBold;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max32
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.max28
              : ROW_SPACING.max24;
          letterSpacing = !accessibilityBiggerLetterSpacing ? 0 : "1.5px";
          break;
        case TextType.H4bold:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.max18
            : FONT_SIZE.max24;
          fontWeight = FONT_WEIGHT.bold;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max40
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.max32
              : ROW_SPACING.max28;
          letterSpacing = !accessibilityBiggerLetterSpacing ? 0 : "1.5px";
          break;
        case TextType.H5:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.fix16
            : FONT_SIZE.max18;
          fontWeight = FONT_WEIGHT.semiBold;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max32
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.max28
              : ROW_SPACING.fix20;
          letterSpacing = !accessibilityBiggerLetterSpacing ? 0 : "1px";
          break;
        case TextType.H5bold:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.fix16
            : FONT_SIZE.max18;
          fontWeight = FONT_WEIGHT.bold;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max32
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.max28
              : ROW_SPACING.fix20;
          letterSpacing = !accessibilityBiggerLetterSpacing ? 0 : "1px";
          break;
        case TextType.H6:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.fix14
            : FONT_SIZE.fix16;
          fontWeight = FONT_WEIGHT.bold;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max24
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.fix20
              : ROW_SPACING.fix18;
          letterSpacing = !accessibilityBiggerLetterSpacing ? 0 : "1px";
          break;
        case TextType.P1:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.max18
            : FONT_SIZE.max24;
          fontWeight = FONT_WEIGHT.regular;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max40
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.max32
              : ROW_SPACING.max28;
          letterSpacing = !accessibilityBiggerLetterSpacing ? "0" : "1.5px";
          break;

        case TextType.P2:
          fontSize = !accessibilityBiggerText
            ? FONT_SIZE.fix16
            : FONT_SIZE.max18;
          fontWeight = FONT_WEIGHT.regular;
          lineHeight =
            accessibilityBiggerText && accessibilityBiggerLineHeight
              ? ROW_SPACING.max28
              : accessibilityBiggerText || accessibilityBiggerLineHeight
              ? ROW_SPACING.max24
              : ROW_SPACING.fix20;
          letterSpacing = !accessibilityBiggerLetterSpacing ? "0.5px" : "1px";
          break;

        default:
          color = COLORS.RaisinBlack;
          fontSize = FONT_SIZE.fix14;
          fontWeight = FONT_WEIGHT.regular;
          lineHeight = "normal";
      }

      return css`
        font-size: ${fontSize};
        font-weight: ${fontWeight};
        letter-spacing: ${letterSpacing};
        line-height: ${lineHeight};
        color: ${color};

        & .paragraph {
          margin-bottom: 1em;
        }
      `;
    }}
  }
`;

export const Img = styled.img`
  background-position: center;
  background-size: cover;
`;
